<template>
    <div class="orgDetail">
        <div class="left-box">
            <LeftPage :active="curTab" :role="role" @tabChange="tabChange"/>
        </div>
        <div class="right-box">
            <div class="table-box">
                <div class="flex justify-between">
                    <div class="title">
                        <div class="icon-box">
                            <i class="iconfont icon-yonghushenhe"></i>
                        </div>
                        <b>审核管理</b>
                    </div>
                    <div class="page-cancel" @click="$router.go(-1)">
                        <i class="icon iconfont icon-jiantouzuo1"></i>返回
                    </div>
                </div>
                <div class="list ">
                    <el-table
                        :cell-style="textCenter"
                        :data="tableData"
                        :header-cell-style="centerbgc"
                        border
                        style="width: 100%">
                        <el-table-column
                            label="序号"
                            type="index"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            label="字段"
                            prop="field_name_str">
                        </el-table-column>
                        <el-table-column
                            label="调整内容"
                            prop="field_value">
                          <template slot-scope="scope" >
                            <div>
                              <div class="item" v-for="(item,index) in scope.row.field_value" :key="index">
                                <p>{{item.name}}</p>
                                <el-link :href="item.url" v-if="item.url" type="primary" target="_blank">查看附件</el-link>
                              </div>
                            </div>
<!--                            <div v-else>{{scope.row.field_value}}</div>-->
                          </template>
                        </el-table-column>
                        <el-table-column
                            label="调整时间"
                            prop="create_time"
                            width="200">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="250">
                            <template slot-scope="scope">
                              <div class="flex align-center justify-center">
                                  <template v-if="scope.row.status === 0">
                                      <el-link class="margin-right-sm" type="primary"  @click="submitAudit(1, scope.row)">通过</el-link>
                                      <edit-reason :params="scope.row"  @reason="submitReason">
                                          <el-link  type="danger">拒绝</el-link>
                                      </edit-reason>
                                  </template>
                                  <el-link type="success" v-if="scope.row.status === 1">已通过</el-link>
                                  <el-link type="danger" v-if="scope.row.status === 2">已拒绝</el-link>
                              </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="page-box">
                    <el-pagination
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        background
                        class="page-all margin-top self-end"
                        layout="prev, pager, next"
                        @current-change="getList">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {shenhe_lst, shenheOrgInfo} from "@/api/admin";
import LeftPage from "@/views/admin/pages/orgApply/common/leftPage";
import EditReason from "@/components/EditReasonDialog";
import {confirm} from "@/utils/utils";

export default {
    name: "orgApply",
    data() {
        return {
            id: '',
            curTab: 1,
            search: {
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],
            role: [],
        }
    },
    components: {EditReason, LeftPage},
    computed: {
        textCenter() {
            return {
                textAlign: 'center'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                background: '#f7f7f7'
            }
        }
    },
    created() {
        this.id = this.$route.query.org_id
        this.$emit("setActive", {
            headActive: 2
        })
        this.getList()
    },
    methods: {
        async getList() {
            let _data = await shenhe_lst(
                this.curTab,
                this.id,
                this.search.page,
                this.search.limit
            );
            if (_data.status == 200) {

                this.tableData = _data.data.data
                this.role = _data.data.model_id
                this.search.total = _data.data.total
                // if (this.role.length !== 0){
                //     let _active = this.role[0]
                //     this.tabChange(_active)
                // }
            } else {
                this.$message.error(_data.msg)
            }
          console.log(this.tableData)
        },
        searchList() {
            this.search.page = 1
            this.getList()
        },
        submitAudit(type,data) {
            confirm('提示', '确定通过该申请吗?', () => {
                this.auditInfo(type,data.id);
            })
        },
        submitReason(data) {
            this.auditInfo(2,data.id,data.reason,data.ref)
        },
        async auditInfo(type,id,reason = '',ref = '') {
            let _data = await shenheOrgInfo(id,reason,type)
            if (_data.status === 200) {
                this.searchList()
                ref && ref.cancel()
                this.$message.success('审核成功')
            }else {
                this.$message.error(_data.msg)
            }
        },
        tabChange(e){
            if (this.curTab === e) return
            this.curTab = e
            this.searchList()
        }
    },
    watch: {},
    filters: {
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}
.item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    margin-left: 20px;
  }
}
.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;
        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }
        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px
            rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}
.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
    height: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        min-height: calc(100vh - (173px + 159px));

        .tab {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: solid 2px #e3e7f0;

            span {
                width: max-content;
                margin-left: 45px;
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: #63686e;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    color: #2791ff;
                    font-weight: bold;
                    border-radius: 2px;
                    border-bottom: solid 4px #2791ff;
                }
            }
        }


        .list {
            width: 100%;

            .btn {
                width: 60px;
                height: 26px;
                border-radius: 4px;
                font-size: 14px;
                text-align: center;
                line-height: 26px;
                margin: 0 auto;

                &.gray {
                    color: #8a8a8a;
                    background-color: #f2f2f2;
                }

                &.yellow {
                    color: #fad471;
                    background-color: #fffbdd;
                }

                &.orange {
                    color: #f58739;
                    background-color: #ffeedd;
                }

                &.red {
                    color: #f8001a;
                    background-color: #ffdddd;
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                min-width: 113px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                padding: 0 20px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-left: 15px;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }
}
</style>


